import {UserService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        users: []
    },

    mutations: {
        saveUsers(state, users) {
            state.users.splice(0);
            state.users = [...users];
        }
    },

    actions: {
        async getUsersAction({commit}) {
            await bindLoading(commit,
                async () => commit('saveUsers', await UserService.getAll()), 'user');
        },

        async removeUserAction({commit, state}, id) {
            return await bindLoading(commit,
                async () => {
                    const res = await UserService.remove(id);
                    if (res.success) {
                        commit('saveUsers', state.users.filter(f => f.id !== id));
                    }
                    return res;
                }, 'user');
        },

        async addUserAction({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await UserService.insert(item);
                    if (res.success) {
                        commit('saveUsers', [...state.users, res.instance]);
                    }
                    return res;
                }, 'user');
        },

        async updateUserAction({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await UserService.update(item);
                    if (res.success) {
                        const idx = state.users.findIndex(m => m.id === item.id);
                        commit('saveUsers',
                            [
                                ...state.users.filter((_, i) => i < idx),
                                res.instance,
                                ...state.users.filter((_, i) => i > idx)
                            ]);
                    }
                    return res;
                }, 'user');
        }
    }

}